/*eslint-disable */
import { useRouter } from 'next/router'
import en from 'public/locales/en/en.js'
import vi from 'public/locales/vi/vi.js'

// The default locale is `en`, but en.js is missing whole sections (e.g.
// `setting`, `user`) that only exist in vi.js. Pages that read those keys
// (trans.setting.title, trans.user.userManagement.title, ...) dereference
// `undefined` during SSR and crash the page with HTTP 500. Deep-merge vi as a
// fallback so any key absent from en falls back to the vi value (en still wins
// where it defines a value). Prevents the crash on /setting, /user/user,
// /user/notification and any other partially-translated page.
function deepMerge(base: any, override: any): any {
  if (Array.isArray(base) || Array.isArray(override)) return override ?? base
  if (typeof base !== 'object' || base === null) return override ?? base
  const out: any = { ...base }
  for (const key of Object.keys(override || {})) {
    const b = base ? base[key] : undefined
    const o = override[key]
    out[key] =
      o && typeof o === 'object' && !Array.isArray(o) && b && typeof b === 'object' && !Array.isArray(b)
        ? deepMerge(b, o)
        : o
  }
  return out
}

// Computed once at module load (translation objects are static imports).
const enWithFallback = deepMerge(vi, en)

const useTrans = () => {
  const { locale } = useRouter()

  const trans = locale === 'vi' ? vi : enWithFallback

  return trans
}

export default useTrans
